// Opens the ticket in its helpdesk; the link is looked up only on click.

import { useState } from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/sonner';
import { sentinelWorkspaceService } from '@/services/sentinelWorkspace.service';

export function OpenInHelpdeskButton({ ticketId }: { ticketId: number }) {
  const [opening, setOpening] = useState(false);

  const open = async (): Promise<void> => {
    // Opened before the await: browsers block a tab opened after it as a popup.
    const tab = window.open('', '_blank');
    setOpening(true);
    try {
      const { ticketUrl } = await sentinelWorkspaceService.getHelpdeskUrl(ticketId);
      if (!ticketUrl) throw new Error('No helpdesk link for this ticket');
      if (tab) {
        tab.opener = null;
        tab.location.href = ticketUrl;
      } else {
        window.open(ticketUrl, '_blank', 'noreferrer');
      }
    } catch {
      tab?.close();
      toast.error("Couldn't find this ticket in the helpdesk");
    } finally {
      setOpening(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={() => void open()}
      disabled={opening}
      className="text-gray-900"
      aria-label="Open in helpdesk"
      title="Open in helpdesk"
    >
      {opening ? <Loader2 className="size-[14px] animate-spin" /> : <ExternalLink className="size-[14px]" />}
    </Button>
  );
}
